import CardPreview from './cardPreview';

export default CardPreview;
